module.exports = __webpack_public_path__ + "img/bca.88b66723.png";